export const styles = () => ({
  pointer: {
    cursor: 'pointer',
    backgroundColor: '#000',
  },
})

export default styles
